import React from 'react'
import HomeContainer from './HomeContainer'
import '../styles/HomePage.css'

export default function HomePage() {

  return (
    <div className="container">
      <HomeContainer />
    </div>
  )
}